/**
 * AV API
 * AV for GWR Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AvReferenzNummerSearchResponse } from '../model/models';
import { GeometergeschaeftDetailEntryMeta } from '../model/models';
import { GeometergeschaeftSearchRequest } from '../model/models';
import { GeometergeschaeftSearchRequestMeta } from '../model/models';
import { GeometergeschaeftSearchResponse } from '../model/models';
import { LoadGeoGeschaeftSichtByGrundstueckIdsRequest } from '../model/models';
import { LoadGeoGeschaeftSichtResponse } from '../model/models';
import { LoadGeoGeschaeftSichtResponseMeta } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AvgeometergeschaeftService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param gbGeschaeftId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadAvReferenzNummerBy(gbGeschaeftId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<AvReferenzNummerSearchResponse>;
    public loadAvReferenzNummerBy(gbGeschaeftId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<AvReferenzNummerSearchResponse>>;
    public loadAvReferenzNummerBy(gbGeschaeftId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<AvReferenzNummerSearchResponse>>;
    public loadAvReferenzNummerBy(gbGeschaeftId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (gbGeschaeftId === null || gbGeschaeftId === undefined) {
            throw new Error('Required parameter gbGeschaeftId was null or undefined when calling loadAvReferenzNummerBy.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (gbGeschaeftId !== undefined && gbGeschaeftId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gbGeschaeftId, 'gbGeschaeftId');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<AvReferenzNummerSearchResponse>(`${this.configuration.basePath}/av/geometergeschaeft/avReferenzNummer`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param geometergeschaeftId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGeometergeschaeftById(geometergeschaeftId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GeometergeschaeftDetailEntryMeta>;
    public loadGeometergeschaeftById(geometergeschaeftId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GeometergeschaeftDetailEntryMeta>>;
    public loadGeometergeschaeftById(geometergeschaeftId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GeometergeschaeftDetailEntryMeta>>;
    public loadGeometergeschaeftById(geometergeschaeftId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (geometergeschaeftId === null || geometergeschaeftId === undefined) {
            throw new Error('Required parameter geometergeschaeftId was null or undefined when calling loadGeometergeschaeftById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (geometergeschaeftId !== undefined && geometergeschaeftId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>geometergeschaeftId, 'geometergeschaeftId');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GeometergeschaeftDetailEntryMeta>(`${this.configuration.basePath}/av/geometergeschaeft`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gbGeschaeftId 
     * @param off 
     * @param lim 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGeometergeschaeftSichtGbGeschaeft(gbGeschaeftId: string, off: number, lim: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadGeoGeschaeftSichtResponse>;
    public loadGeometergeschaeftSichtGbGeschaeft(gbGeschaeftId: string, off: number, lim: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadGeoGeschaeftSichtResponse>>;
    public loadGeometergeschaeftSichtGbGeschaeft(gbGeschaeftId: string, off: number, lim: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadGeoGeschaeftSichtResponse>>;
    public loadGeometergeschaeftSichtGbGeschaeft(gbGeschaeftId: string, off: number, lim: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (gbGeschaeftId === null || gbGeschaeftId === undefined) {
            throw new Error('Required parameter gbGeschaeftId was null or undefined when calling loadGeometergeschaeftSichtGbGeschaeft.');
        }
        if (off === null || off === undefined) {
            throw new Error('Required parameter off was null or undefined when calling loadGeometergeschaeftSichtGbGeschaeft.');
        }
        if (lim === null || lim === undefined) {
            throw new Error('Required parameter lim was null or undefined when calling loadGeometergeschaeftSichtGbGeschaeft.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (gbGeschaeftId !== undefined && gbGeschaeftId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gbGeschaeftId, 'gbGeschaeftId');
        }
        if (off !== undefined && off !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>off, 'off');
        }
        if (lim !== undefined && lim !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>lim, 'lim');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadGeoGeschaeftSichtResponse>(`${this.configuration.basePath}/av/geometergeschaeft/sicht/gbGeschaeft`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gbGeschaeftId 
     * @param off 
     * @param lim 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGeometergeschaeftSichtGbMeldung(gbGeschaeftId: string, off: number, lim: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadGeoGeschaeftSichtResponse>;
    public loadGeometergeschaeftSichtGbMeldung(gbGeschaeftId: string, off: number, lim: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadGeoGeschaeftSichtResponse>>;
    public loadGeometergeschaeftSichtGbMeldung(gbGeschaeftId: string, off: number, lim: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadGeoGeschaeftSichtResponse>>;
    public loadGeometergeschaeftSichtGbMeldung(gbGeschaeftId: string, off: number, lim: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (gbGeschaeftId === null || gbGeschaeftId === undefined) {
            throw new Error('Required parameter gbGeschaeftId was null or undefined when calling loadGeometergeschaeftSichtGbMeldung.');
        }
        if (off === null || off === undefined) {
            throw new Error('Required parameter off was null or undefined when calling loadGeometergeschaeftSichtGbMeldung.');
        }
        if (lim === null || lim === undefined) {
            throw new Error('Required parameter lim was null or undefined when calling loadGeometergeschaeftSichtGbMeldung.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (gbGeschaeftId !== undefined && gbGeschaeftId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gbGeschaeftId, 'gbGeschaeftId');
        }
        if (off !== undefined && off !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>off, 'off');
        }
        if (lim !== undefined && lim !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>lim, 'lim');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadGeoGeschaeftSichtResponse>(`${this.configuration.basePath}/av/geometergeschaeft/sicht/gbmeldung`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundstueckIds 
     * @param off 
     * @param lim 
     * @param sdir 
     * @param sort 
     * @param auftragLoadOption 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGeometergeschaeftSichtGrundstueckGet(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'NUMMER' | 'STATUS' | 'AUFTRAG_DATUM' | 'AV_MUTATION' | 'GESCHAEFT_ART', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadGeoGeschaeftSichtResponseMeta>;
    public loadGeometergeschaeftSichtGrundstueckGet(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'NUMMER' | 'STATUS' | 'AUFTRAG_DATUM' | 'AV_MUTATION' | 'GESCHAEFT_ART', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadGeoGeschaeftSichtResponseMeta>>;
    public loadGeometergeschaeftSichtGrundstueckGet(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'NUMMER' | 'STATUS' | 'AUFTRAG_DATUM' | 'AV_MUTATION' | 'GESCHAEFT_ART', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadGeoGeschaeftSichtResponseMeta>>;
    public loadGeometergeschaeftSichtGrundstueckGet(grundstueckIds: string, off: number, lim: number, sdir: 'ASC' | 'DESC', sort: 'NUMMER' | 'STATUS' | 'AUFTRAG_DATUM' | 'AV_MUTATION' | 'GESCHAEFT_ART', auftragLoadOption?: 'ALLE' | 'HAENGIGE', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundstueckIds === null || grundstueckIds === undefined) {
            throw new Error('Required parameter grundstueckIds was null or undefined when calling loadGeometergeschaeftSichtGrundstueckGet.');
        }
        if (off === null || off === undefined) {
            throw new Error('Required parameter off was null or undefined when calling loadGeometergeschaeftSichtGrundstueckGet.');
        }
        if (lim === null || lim === undefined) {
            throw new Error('Required parameter lim was null or undefined when calling loadGeometergeschaeftSichtGrundstueckGet.');
        }
        if (sdir === null || sdir === undefined) {
            throw new Error('Required parameter sdir was null or undefined when calling loadGeometergeschaeftSichtGrundstueckGet.');
        }
        if (sort === null || sort === undefined) {
            throw new Error('Required parameter sort was null or undefined when calling loadGeometergeschaeftSichtGrundstueckGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckIds !== undefined && grundstueckIds !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>grundstueckIds, 'grundstueckIds');
        }
        if (auftragLoadOption !== undefined && auftragLoadOption !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>auftragLoadOption, 'auftragLoadOption');
        }
        if (off !== undefined && off !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>off, 'off');
        }
        if (lim !== undefined && lim !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>lim, 'lim');
        }
        if (sdir !== undefined && sdir !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sdir, 'sdir');
        }
        if (sort !== undefined && sort !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sort, 'sort');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadGeoGeschaeftSichtResponseMeta>(`${this.configuration.basePath}/av/geometergeschaeft/sicht/grundstueck`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param loadGeoGeschaeftSichtByGrundstueckIdsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGeometergeschaeftSichtGrundstueckPost(loadGeoGeschaeftSichtByGrundstueckIdsRequest: LoadGeoGeschaeftSichtByGrundstueckIdsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadGeoGeschaeftSichtResponseMeta>;
    public loadGeometergeschaeftSichtGrundstueckPost(loadGeoGeschaeftSichtByGrundstueckIdsRequest: LoadGeoGeschaeftSichtByGrundstueckIdsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadGeoGeschaeftSichtResponseMeta>>;
    public loadGeometergeschaeftSichtGrundstueckPost(loadGeoGeschaeftSichtByGrundstueckIdsRequest: LoadGeoGeschaeftSichtByGrundstueckIdsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadGeoGeschaeftSichtResponseMeta>>;
    public loadGeometergeschaeftSichtGrundstueckPost(loadGeoGeschaeftSichtByGrundstueckIdsRequest: LoadGeoGeschaeftSichtByGrundstueckIdsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (loadGeoGeschaeftSichtByGrundstueckIdsRequest === null || loadGeoGeschaeftSichtByGrundstueckIdsRequest === undefined) {
            throw new Error('Required parameter loadGeoGeschaeftSichtByGrundstueckIdsRequest was null or undefined when calling loadGeometergeschaeftSichtGrundstueckPost.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<LoadGeoGeschaeftSichtResponseMeta>(`${this.configuration.basePath}/av/geometergeschaeft/sicht/grundstueck`,
            loadGeoGeschaeftSichtByGrundstueckIdsRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param geometergeschaeftSearchRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGeometergeschaeftStandard(geometergeschaeftSearchRequest: GeometergeschaeftSearchRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GeometergeschaeftSearchResponse>;
    public searchGeometergeschaeftStandard(geometergeschaeftSearchRequest: GeometergeschaeftSearchRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GeometergeschaeftSearchResponse>>;
    public searchGeometergeschaeftStandard(geometergeschaeftSearchRequest: GeometergeschaeftSearchRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GeometergeschaeftSearchResponse>>;
    public searchGeometergeschaeftStandard(geometergeschaeftSearchRequest: GeometergeschaeftSearchRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (geometergeschaeftSearchRequest === null || geometergeschaeftSearchRequest === undefined) {
            throw new Error('Required parameter geometergeschaeftSearchRequest was null or undefined when calling searchGeometergeschaeftStandard.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<GeometergeschaeftSearchResponse>(`${this.configuration.basePath}/av/geometergeschaeft/searchStandard`,
            geometergeschaeftSearchRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGeometergeschaeftStandardTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GeometergeschaeftSearchRequestMeta>;
    public searchGeometergeschaeftStandardTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GeometergeschaeftSearchRequestMeta>>;
    public searchGeometergeschaeftStandardTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GeometergeschaeftSearchRequestMeta>>;
    public searchGeometergeschaeftStandardTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GeometergeschaeftSearchRequestMeta>(`${this.configuration.basePath}/av/geometergeschaeft/searchStandard`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
